import React, { lazy } from 'react'
import { useModals } from '../../shared/hooks/useModals'
import DelayUnmount from '../DelayUnmount'
const ModalCreateTestimoni = lazy(() => import('../ModalCreateTestimoni/ModalCreateTestimoni'))
function TestimoniModals() {
    const { modalState, showModal, closeModal } = useModals()
    return (
        <React.Fragment>
            <DelayUnmount mount={modalState.createTestimoni.show}>
                <ModalCreateTestimoni
                    open={modalState?.createTestimoni?.show}
                    onClose={() => {
                        closeModal("createTestimoni")
                    }}
                />
            </DelayUnmount>
            <DelayUnmount mount={modalState.editTestimoni.show}>
                <ModalCreateTestimoni
                    open={modalState?.editTestimoni?.show}
                    onClose={() => {
                        closeModal("editTestimoni")
                    }}
                    dataTestimoni={modalState.editTestimoni?.data}
                    isEdit={true}
                />
            </DelayUnmount>
        </React.Fragment>
    )
}

export default TestimoniModals